import request from '@/utils/request'

// 计划达交率汇总报表
export function apiGetPlanDeliveryRateList (query) {
	return request({
		url: `/inv/invReportPlanDelivery/deliveryRateList`,
		method: 'get',
		params: query
	})
}

// 导出计划达交率汇总报表
export function apiPlanDeliveryRateListExport (data) {
	return request({
		url: `/inv/invReportPlanDelivery/v2/deliveryRateListExport`,
		method: 'post',
		data: data
	})
}

// 计划完成率汇总报表
export function apiGetPlanCompletedRateList (query) {
	return request({
		url: `/inv/invReportPlanDelivery/completedRateList`,
		method: 'get',
		params: query
	})
}

export function apiPlanCompletedRateListExport (data) {
	return request({
		url: `/inv/invReportPlanDelivery/v2/completedRateListExport`,
		method: 'post',
		data: data
	})
}

// 计划达交率明细报表导出
export function apiDeliveryRateDetailExport (data) {
  return request({
    url: `/inv/invReportPlanDelivery/deliveryRateDetailExport`,
    method: 'post',
    data: data
  })
}
// 计划完成率明细报表导出
export function apiCompletedRateDetailExport (data) {
  return request({
    url: `/inv/invReportPlanDelivery/completedRateDetailExport`,
    method: 'post',
    data: data
  })
}

// 计划达交率报表-明细
export function apiGetDeliveryRateDetailList (query) {
	return request({
		url: `/inv/invReportPlanDelivery/deliveryRateDetailList`,
		method: 'get',
		params: query
	})
}

// 计划完成率报表-明细
export function apiGetCompletedRateDetailList (query) {
	return request({
		url: `/inv/invReportPlanDelivery/completedRateDetailList`,
		method: 'get',
		params: query
	})
}
